import React from 'react'

// A button's label, swapped for the app's standard button spinner while
// loading — the label stays in place (just hidden) so the button doesn't
// shrink around the spinner
const EmailVerificationButtonLabel = ({ label, loading }) => (
  <React.Fragment>
    <span className={loading ? 'emailVerificationFlow-btnLabel--hidden' : undefined}>{label}</span>
    {loading && (
      <div className='button-loadingSpinnerContainer'>
        <div className='button-loadingSpinner' />
      </div>
    )}
  </React.Fragment>
)

export default EmailVerificationButtonLabel
